interface V3IconMenuProps extends React.SVGProps<SVGSVGElement> {
    fill?: string;
}

export const V3IconMenu = ({ fill = "#ABB0BA", ...rest }: V3IconMenuProps) => <svg width="24" height="24" {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="11" width="20" height="2" rx="1" fill={fill} />
    <rect x="2" y="5" width="20" height="2" rx="1" fill={fill} />
    <rect x="2" y="17" width="20" height="2" rx="1" fill={fill} />
</svg>